export default "__VITE_ASSET__pYsG_FCm__"